import(/* webpackMode: "eager" */ "/app/src/components/BlogList.tsx")